import { Button, Typography } from '@mui/material';
import { Fragment } from 'react';

export interface BackCrumb {
    label: string;
    onSelect: () => void;
}

interface BackCrumbsProps {
    crumbs: BackCrumb[];
}

export const BackCrumbs = ({ crumbs }: BackCrumbsProps) => {
    return (
        <>
            {crumbs.map((crumb, index) => (
                <Fragment key={`${crumb.label}-${index}`}>
                    {index > 0 ? (
                        <Typography
                            variant="body2"
                            sx={{ marginLeft: '8px', marginRight: '8px' }}
                        >
                            /
                        </Typography>
                    ) : null}
                    <Button
                        onClick={crumb.onSelect}
                        sx={{
                            minWidth: 0,
                            padding: 0,
                            color: 'inherit',
                            textTransform: 'none',
                            marginLeft: index === 0 ? '8px' : 0,
                            ':hover': {
                                backgroundColor: 'transparent',
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        <Typography variant="body2">{crumb.label}</Typography>
                    </Button>
                </Fragment>
            ))}
        </>
    );
};
